import { create } from 'zustand';

const defaultState: useConfirmDialogStoreState = {
    isOpen: false,
    title: '',
    message: '',
    onConfirm: () => {},
    onCancel: () => {},
};

export const useConfirmDialogStore = create<useConfirmDialogStoreState & useConfirmDialogStoreAction>()((set) => ({
    ...defaultState,
    action: {
        setIsOpen: (isOpen) => set(() => ({ isOpen })),
        setTitle: (title) => set(() => ({ title })),
        setMessage: (message) => set(() => ({ message })),
        setOnConfirm: (onConfirm) => set(() => ({ onConfirm })),
        setOnCancel: (onCancel) => set(() => ({ onCancel })),
        openConfirmDialog: (title, message, onConfirm, onCancel) =>
            set(() => ({
                isOpen: true,
                title,
                message,
                onConfirm: onConfirm || (() => {}),
                onCancel: onCancel || (() => {}),
            })),
        closeConfirmDialog: () =>
            set(() => ({
                isOpen: false,
                title: '',
                message: '',
                onConfirm: () => {},
                onCancel: () => {},
            })),
    },
}));

export const useOpenConfirmDialog = () => useConfirmDialogStore((state) => state.action.openConfirmDialog);

interface useConfirmDialogStoreState {
    isOpen: boolean;
    title: string;
    message: string;
    onConfirm: () => void;
    onCancel: () => void;
}

interface useConfirmDialogStoreAction {
    action: {
        setIsOpen: (isOpen: boolean) => void;
        setTitle: (title: string) => void;
        setMessage: (message: string) => void;
        setOnConfirm: (onConfirm: () => void) => void;
        setOnCancel: (onCancel: () => void) => void;
        openConfirmDialog: (title: string, message: string, onConfirm?: () => void, onCancel?: () => void) => void;
        closeConfirmDialog: () => void;
    };
}
